import { PaymentMethodsCommandNames, sendRioEvent, SpecType, StatusTypes, SubType } from '@chegg/commerce-utils';
import { verify } from '@chegg/user-address';
import { doFireStatusUpdate, sendRioEventCallback } from '../../../../utils/CallbackUtils';
import { ERRORS } from '../../../../constants/Errors';
import { getString } from '../../../../constants/Strings';
import { updatePaymentState } from '../../../PaymentState/PaymentState.actions';
import { fetchExistingMop } from './fetchExistingMop';
import { Component } from '../../../../constants/CallbackConstants';
import { getPaymentServerErrorText } from '../../../../internals/PaymentForm/helpers';
import { PaymentFormDataFields } from '../../../../internals/UserAddress/constants';
/**
 * Util to verify and fetch existing mops
 * @param params
 * @returns
 */ // NOTE: isFetchPaymentMethodEnabled will be false if appMode is ADD or EDIT
export var verifyExistingMop = function verifyExistingMop(_ref) {
  var isFetchPaymentMethodEnabled = _ref.isFetchPaymentMethodEnabled,
    dispatch = _ref.dispatch,
    selectedMop = _ref.selectedMop,
    shouldValidateExistingMopsZipcodes = _ref.shouldValidateExistingMopsZipcodes,
    deviceData = _ref.deviceData,
    debug = _ref.debug,
    rioNamespace = _ref.rioNamespace,
    paymentErrorModal = _ref.paymentErrorModal;
  if (!isFetchPaymentMethodEnabled) return false;
  var billingAddress = selectedMop.billingAddress;
  var zip = billingAddress.zip,
    country = billingAddress.country,
    city = billingAddress.city,
    state = billingAddress.state;
  var verifyCallback = function verifyCallback(isValid) {
    if (isValid) {
      fetchExistingMop(selectedMop, deviceData);
    } else {
      dispatch(updatePaymentState({
        message: {
          text: getPaymentServerErrorText(paymentErrorModal, PaymentFormDataFields.FETCH_INVALID_ZIP) || getString('APP.FETCH.PAYMENT.METHOD.INVALID.ZIP'),
          type: StatusTypes.ERROR,
          code: ERRORS.INVALID_ZIPCODE.code
        }
      }));
      doFireStatusUpdate([{
        status: StatusTypes.ERROR,
        command: PaymentMethodsCommandNames.FETCH_PAYMENT_METHOD,
        payload: {
          component: 'PaymentMethods',
          context: Component.EXECUTE_COMMAND_LOGIC,
          errors: [ERRORS.INVALID_ZIPCODE]
        }
      }]);
      sendRioEvent({
        info: ERRORS.INVALID_ZIPCODE.message,
        specType: SpecType.NOTIFICATION,
        subType: SubType.ERROR,
        callback: sendRioEventCallback,
        namespace: rioNamespace,
        message_detail: 'Asking user to edit MOP with zip: ${zip}, country: ${country}',
        message_id: ERRORS.INVALID_ZIPCODE.code
      });
    }
  };
  if (shouldValidateExistingMopsZipcodes) {
    verify({
      type: 'zipByRegex',
      address: {
        city: city,
        state: state,
        countryISO: country,
        zipCode: zip
      },
      regexValidation: true,
      callback: verifyCallback,
      debug: debug
    });
  } else {
    fetchExistingMop(selectedMop, deviceData);
  }
  return true;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/redux/CommandState/commands/helpers/verifyExistingMop.js
// module id = 4407
// module chunks = 11